"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerProductReturnShippingModes = void 0;
var CustomerProductReturnShippingModes;
(function (CustomerProductReturnShippingModes) {
    CustomerProductReturnShippingModes["TAKE_AWAY"] = "1";
    CustomerProductReturnShippingModes["DELIVERY"] = "2";
})(CustomerProductReturnShippingModes = exports.CustomerProductReturnShippingModes || (exports.CustomerProductReturnShippingModes = {}));
